import { Assets } from 'pixi.js'
import { soundManager } from '@slot-nx/core'
import { gameConfig } from '../../config'
import { loadLibAssets, loadLoadingImage } from './libAssetUtil'

import fntW from '/resource/font/fontW.fnt?url'
import fntS from '/resource/font/fontS.fnt?url'
import fnt_TBW from '/resource/font/TBWfont.fnt?url'
import fntW_WIN from '/resource/font/Wfont.fnt?url'
import fntGodzi from '/resource/font/fontG.fnt?url'
import { getFreeGameSpineData } from '../freeGame/service/freeGameService'
import { getWinningPanelSpinData } from '../winning/service/winningPanelService'
import { getGodziSpineData, getloadingPageSpineData } from './resource/spineResource'
import {
  geMultiplierReelDatas,
  getBetHistoryImageDatas,
  getTableBgDatas,
  getVoucherImageDatas,
} from './resource/imageResource'
import { getBackgroundSpineData } from '../../components/Background'
import { loadFonts } from './resource/fonts'

export class AssetManager {
  async loadEssential() {
    await Promise.all([
      Assets.loadBundle([
        'Symbol',
        'Bet',
        'Rules',
        'SpinButton',
        'AutoButton',
        'BetHistoryButton',
        'Leave Game Button',
        'MenuButton',
        'SoundButton',
        'MultiplierReel',
        'extrabet',
        'background',
        'SwitchGameTypeTab',
        'Loading',
        'DetailPageControl',
        'PayoutDetailBoxImage',
        'godziImage',
        'buyBonus',
        'HSMenuButton',
        'HSSpeedButton',
        'ChangePose',
        'PayTable',
        'HSLeaveGameButton',
        'HSRules',
        'HSSoundButton',
        'Godzidrop',
      ]),
      Assets.load([fntS, fntW, fntW_WIN, fnt_TBW, fntGodzi]),
      loadFonts(),
      soundManager.load(gameConfig.sounds, { customStorageKey: gameConfig.name }),
    ])

    await Promise.all([
      loadLibAssets(),
      Assets.load(getBackgroundSpineData()),
      Assets.load(getFreeGameSpineData()),
      Assets.load(getWinningPanelSpinData()),
      Assets.load(getloadingPageSpineData()),
      Assets.load(geMultiplierReelDatas()),
      Assets.load(getTableBgDatas()),
      Assets.load(getGodziSpineData()),
      Assets.load(getVoucherImageDatas()),
      Assets.load(getBetHistoryImageDatas()),
    ])
  }

  async loadOpbetDetail() {
    await Promise.all([
      Assets.loadBundle([
        'Symbol',
        'SwitchGameTypeTab',
        'Loading',
        'DetailPageControl',
        'PayoutDetailBoxImage',
        'MultiplierReel',
        'godziImage',
      ]),
      Assets.load([fntS, fntW, fntGodzi]),
    ])
    await Promise.all([
      Assets.load(geMultiplierReelDatas()),
      Assets.load(getTableBgDatas()),
      loadLoadingImage(),
    ])
  }

  async loadBackground() {
    await Promise.all([
      Assets.load(['icon_infinity', 'icon_infinity_close', 'arrow']),
      Assets.loadBundle(['AutoPlayAction']),
    ])
  }
}
